import { configureStore } from "@reduxjs/toolkit";
import blogsReducer from "../features/blogs/blogsSlice";
import filterReducer from "../features/filter/filterSlice";
import blogReducer from "../features/blog/blogSlice";
import likeSavedReducer from "../features/likeSaved/likeSavedSlice";
import relatedBlogsReducer from "../features/relatedBlogs/relatedBlogsSlice";

export const store = configureStore({
    reducer: {
        blogs: blogsReducer,
        filter: filterReducer,
        blog: blogReducer,
        likeSaved: likeSavedReducer,
        relatedBlogs: relatedBlogsReducer,
    },
});
